import styled from 'styled-components'

export const ProjectContainer = styled.div`
	.item-title {
		font-size: 14px;
		color: #999999;
	}

	.item-detail {
		font-weight: bold;
		font-size: 14px;
		color: #373737;
	}
`
